import { useContext } from 'react'
import { CurrentAgencyContext } from 'contexts'
import { DEFAULT_AGENCY_STATUS } from 'contexts/CurrentAgencyContext'

export const useCurrentAgency = (
  licensedAgencyId: string | undefined | null,
) => {
  const { state, dispatch } = useContext(CurrentAgencyContext)

  // if the currently stored licensed agency id does not match our desired id, then return the default state
  if (
    !licensedAgencyId ||
    (state.agency?.data?.licensedAgencyId &&
      state.agency.data.licensedAgencyId !== licensedAgencyId)
  ) {
    return {
      state: DEFAULT_AGENCY_STATUS.state,
      dispatch,
    }
  }

  return {
    state,
    dispatch,
  }
}
